export default __webpack_public_path__ + "static/social-trends-states_en-639b96a27b5745e91a932df1a6ef454e.png";